var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2461 0.984375C27.9102 0.59375 28.5742 0.632812 29.2383 1.10156C29.9023 1.53125 30.1758 2.13672 30.0586 2.91797L26.3086 27.3516C26.1914 27.9375 25.8594 28.3867 25.3125 28.6992C24.8047 29.0117 24.2773 29.0508 23.7305 28.8164L16.2891 25.7109L12.7734 30.0469C12.2266 30.75 11.5234 30.9453 10.6641 30.6328C9.84375 30.3594 9.43359 29.7734 9.43359 28.875V22.8984L1.23047 19.5C0.488281 19.1875 0.0976562 18.6602 0.0585938 17.918C0.0195312 17.1367 0.332031 16.5508 0.996094 16.1602L27.2461 0.984375ZM11.3086 28.875L14.4727 25.0078L11.3086 23.6602V28.875ZM24.4336 27.0586L28.1836 2.625L1.93359 17.7422L8.61328 20.4961L23.5547 7.78125C23.7109 7.625 23.8672 7.625 24.0234 7.78125C24.1797 7.9375 24.1797 8.09375 24.0234 8.25L12.3633 22.0781L24.4336 27.0586Z",
    fill: "url(#paint0_linear_2083_581)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2083_581",
    x1: 0.671111,
    y1: 36.2333,
    x2: 35.4135,
    y2: 5.93931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#7D50FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3969E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.5b70f2ce.svg";
export { ForwardRef as ReactComponent };